import { Component, OnInit } from "@angular/core";
import { ModalController, NavController, NavParams } from "@ionic/angular";
import { AlertandloadingService } from "src/app/services/alertandloading.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-asset-transaction",
  templateUrl: "./asset-transaction.page.html",
  styleUrls: ["./asset-transaction.page.scss"],
})
export class AssetTransactionPage implements OnInit {
  securityCode: string;
  verificationMethod: string = "authenticator";
  wallet_id: number;
  asset_id: number;
  to_address: string;
  from_address: string;
  amount: number;
  symbol: string;

  activeView: string = "send";
  transactionInfo: any;

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private navParams: NavParams,
    private alertandLoading: AlertandloadingService,
    public api: ApiService
  ) {
    this.wallet_id = this.navParams.get("wallet_id");
    this.asset_id = this.navParams.get("asset_id");
    this.to_address = this.navParams.get("to_address");
    this.from_address = this.navParams.get("from_address");
    this.amount = this.navParams.get("amount");
    this.symbol = this.navParams.get("symbol");
  }

  ngOnInit() {
    this.prepareSecurityVerification();
  }

  closeModal() {
    this.modalCtrl.dismiss(this.transactionInfo);
  }

  async submit() {
    if (/^\d{6}$/.test(this.securityCode || "")) {
      let body = new FormData();
      body.append("from_wallet_id", "" + this.wallet_id);
      body.append("to_address", this.to_address);
      body.append("amount", "" + this.amount);
      body.append("asset_id", "" + this.asset_id);
      body.append("security_code", this.securityCode);

      await this.alertandLoading.presentLoading(
        "sending transaction please wait"
      );

      this.api.transferAsset(body).then(
        (result: any) => {
          this.alertandLoading.dismissLoading();
          if (!result.error) {
            this.transactionInfo = result.data.transaction;
            this.activeView = "result";
          } else {
            this.securityCode = "";
            this.alertandLoading.showAlert("Transaction failed", result.message[0]);
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Verification required",
        "Enter the current 6 digit security code"
      );
    }
  }

  async openTwoFactorSetup() {
    await this.modalCtrl.dismiss();
    this.navCtrl.navigateForward("settings/2fa");
  }

  private prepareSecurityVerification() {
    const enabled = this.api.usersession &&
      (this.api.usersession.two_factor_enabled === true || this.api.usersession.two_factor_enabled == 1);
    this.verificationMethod = enabled ? "authenticator" : "setup";
  }
}
